import { ComponentType } from '@angular/cdk/portal';

export class FpxModal<T> {
  private _height: string = '220px';
  private _width: string = '651px';
  private _data: any;
  private _afterClosed: FpxModalAfterClosed | undefined;
  private _afterOpened: FpxModalAfterOpened | undefined;
  private _beforeClosed: FpxModalBeforeClosed | undefined;
  private _id: string | undefined;
  private _component!: ComponentType<T> ;
  private _backdropClass: string | string[] = [];
  private _closeOnNavigation: boolean = true;
  private _disableClose: boolean = true;
  private _hasBackdrop: boolean = true;
  private _autoFocus : boolean = false;
  private _panelClass : string | string[] = '';

  public setHeight(height: string) {
    this._height = height;
  }

  public getHeight(): string {
    return this._height;
  }

  public setWidth(width: string) {
    this._width = width;
  }

  public getWidth(): string {
    return this._width;
  }

  public setData(data: any) {
    this._data = data;
  }

  public getData(): any {
    return this._data;
  }

  public setAfterClosed(afterClosed: FpxModalAfterClosed) {
    this._afterClosed = afterClosed;
  }

  public getAfterClosed(): FpxModalAfterClosed | undefined {
    return this._afterClosed;
  }

  public setAfterOpened(afterOpened: FpxModalAfterOpened) {
    this._afterOpened = afterOpened;
  }

  public getAfterOpened(): FpxModalAfterOpened | undefined {
    return this._afterOpened;
  }

  public setBeforeClosed(afterOpened: FpxModalAfterOpened) {
    this._beforeClosed = afterOpened;
  }

  public getBeforeClosed(): FpxModalBeforeClosed | undefined {
    return this._beforeClosed;
  }

  public setId(id: string) {
    this._id = id;
  }

  public getId(): string | undefined {
    return this._id;
  }

  public setComponent(component: ComponentType<T>) {
    this._component = component;
  }
  public getComponent(): ComponentType<T> {
    return this._component;
  }

  public setBackDropClass(backDropClass: string | string[]) {
    this._backdropClass = backDropClass;
  }

  public getBackDropClass(): string | string[] {
    return this._backdropClass;
  }

  public getHasBackdrop(): boolean {
    return this._hasBackdrop;
  }

  public setDisableClose(disableClose: boolean) {
    this._disableClose = disableClose;
  }

  public getDisableClose(): boolean {
    return this._disableClose;
  }

  public setCloseOnNavigation(closeOnNavigation: boolean) {
    this._closeOnNavigation = closeOnNavigation;
  }

  public getCloseOnNavigation(): boolean {
    return this._closeOnNavigation;
  }

  public setAutoFocus(autoFocus:boolean){
    this._autoFocus = autoFocus
  }
  public getAutoFocus():boolean{
    return this._autoFocus
  }

  public setPanelClass(panelClass:string | string[]){
    this._panelClass = panelClass;
  }
  public getPanelClass():string | string[]{
    return this._panelClass;
  }

}

export interface FpxModalAfterClosed {
  (payload: any): void;
}

export interface FpxModalAfterOpened {
  (payload: any): void;
}

export interface FpxModalBeforeClosed {
  (payload: any): void;
}
